<template>
  <section class="stories mt-8 md:mt-10">
    <p
      class="text-[22px] leading-normal sm:text-[40px] sm:leading-[50px] text-black-900 font-medium mb-5"
    >
      Related Articles
    </p>
    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-8 md:gap-y-14"
    >
      <template v-if="isLoading">
        <div v-for="i in 3" :key="i" class="flex flex-col gap-4">
          <UtilsSkeletonLoading class="w-full h-40" />
          <UtilsSkeletonLoading class="w-1/2 h-10" />
          <UtilsSkeletonLoading class="w-full h-16" />
        </div>
      </template>
      <template v-else-if="data.data.length === 0">
        <p class="text-base text-bw-900">No related articles found</p>
      </template>
      <template v-else>
        <ArticleCard
          v-for="related in data.data"
          :key="related.id"
          :with-logo="false"
          :title="related.attributes?.card_title"
          :desc="related.attributes?.layout_component?.[0]?.description"
          :image-url="related.attributes?.image?.data?.attributes?.url"
          :slug="`/ideas/${related.attributes?.slug}`"
          :is-title-paragraph="true"
        />
      </template>
    </div>
  </section>
</template>

<script setup>
// VARIABLE DECLARATION
const isLoading = ref(true)

// PROPS
const props = defineProps({
  detailId: {
    type: Number,
    default: null
  },
  expertises: {
    type: Array,
    required: true
  },
  industries: {
    type: Array,
    required: true
  }
})

const query = {
  'filters[layout][$eq]': 'article',
  'filters[$and][0][id][$ne]': props.detailId,
  'pagination[pageSize]': 4,
  populate: 'image,layout_component,layout_component.type',
  sort: 'publish_at:desc'
}

if (props.expertises) {
  props.expertises.forEach((item, index) => {
    query[`filters[$or][1][expertices][id][$in][${index}]`] = item.id
  })
}

if (props.industries) {
  props.industries.forEach((item, index) => {
    query[`filters[$or][2][industries][id][$in][${index}]`] = item.id
  })
}

// METHODS
const { data, pending } = await useSuitmediaApiData(`/api/contents`, {
  query
})
isLoading.value = pending.value
</script>

<style lang="scss" scoped></style>
